import { HttpVerb } from "../../constants";
const LanguageSwitcherApi = {
  LanguageData: "/api/languageswitcher/"
};

const languageData = async (urlPath, publicationId, mainPage) => {
  return window.ucSDK.api.nonServiceInstance?.request({
    method: HttpVerb.GET,
    url: `${LanguageSwitcherApi.LanguageData}?publicationid=${publicationId}&url=${urlPath}&root=${mainPage}`
  });
};

export default {
  languageData
};
